import {
  Button,
  Form,
  Modal,
  Card,
  Spin,
  message,
  InputNumber,
  Input,
  Typography,
  Divider,
  Upload,
  Row,
  Image,
  Checkbox,
  Col,
  Empty,
  Space,
  Tag,
  Flex,
  Popconfirm,
} from "antd";

import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_BILL_DETAIL,
  POST_CLEAR_PAYMENT,
  POST_DELETE_IMAGE_NEW,
  POST_UPLOAD_IMAGE_NEW,
} from "../../../../API/apiUrls";
import Dragger from "antd/es/upload/Dragger";
import {
  InboxOutlined,
  FilePdfOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import CurrencyFormat from "../../../../../hook/CurrencyFormat";
import Compressor from "compressorjs";
import AddImage from "./AddImage";
import LoadCompanies from "../../../../../hook/LoadCompanies";

const ClearAdvanePayment = ({ open, close, dataDefault, funcUpdateStatus }) => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const { companiesOptions: allCompaniesOptions, loading: loadingCompanies } =
    LoadCompanies();

  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");

  const { TextArea } = Input;
  const { Text } = Typography;
  const [loading, setLoading] = useState(false);
  const [dataRender, setDataRender] = useState([]);
  const [btnOn, setBtnOn] = useState(false);
  const [form] = Form.useForm();
  const [totalPay, setTotalPay] = useState({});
  const [grandTotal, setGrandTotal] = useState(0);

  // แยก fileList สำหรับแต่ละ CONTNO
  const [fileListByContract, setFileListByContract] = useState([]);
  const [fileTranferMoney, setFileTranferMoney] = useState([]);
  // ✅ เพิ่ม State สำหรับจัดการรูปภาพ
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [currentLoan, setCurrentLoan] = useState(null);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  // ✅ Companies Options
  const companiesOptions = useMemo(() => {
    if (!allCompaniesOptions?.length) return [];
    return allCompaniesOptions.filter((item) => item.value <= 3);
  }, [allCompaniesOptions]);

  console.log(companiesOptions);

  useEffect(() => {
    if (dataDefault && open) {
      console.log("dataDefault:", dataDefault);
      loadData();
      loadPath();
      form.resetFields();
      setFileListByContract([]);
      setFileTranferMoney([]);
    }
  }, [dataDefault, open]);

  // ============== LOAD DATA ==============
  const loadData = async () => {
    setLoading(true);

    const payload = {
      TMBILL: [dataDefault.TMBILL],
    };

    try {
      const response = await axios.post(POST_BILL_DETAIL, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (
        response.data &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        console.log("Bill Detail Response:", response.data);
        renderDataDetail(response.data);
      } else {
        message.warning("ไม่พบข้อมูลรายละเอียด");
        setDataRender([]);
      }
    } catch (error) {
      console.error("Error loading bill detail:", error);
      message.error(`เกิดข้อผิดพลาดในการโหลดข้อมูล: ${error.message}`);
      setDataRender([]);
    } finally {
      setLoading(false);
    }
  };

  const loadPath = async () => {
    setLoading(true);
    try {
      const allContNo = dataDefault.ALL_CONTNO || [];

      if (allContNo.length === 0) {
        message.warning("ไม่พบข้อมูล CONTNO");
        setFileListByContract([]);
        return;
      }

      // ✅ 1. ดึงรูปจาก loanId ทุก contract
      const loanPromises = allContNo.map(async (contract) => {
        try {
          const imgRes = await axios.get(
            `${GET_LOAD_IMAGE_NEW_ALL}/6/${contract.loanId}`,
            { headers: HEADERS_UPIMAGE },
          );

          return (imgRes.data || []).map((img) => ({
            ...img,
            CONTNO: contract.CONTNO,
            loanId: contract.loanId,
            lawsuitId: contract.lawsuitId,
          }));
        } catch (error) {
          console.error(`Error loading images for ${contract.CONTNO}:`, error);
          return [];
        }
      });

      // ✅ 2. ดึงรูปจาก idExpen แยกต่างหาก (ครั้งเดียว)
      let tmBillImages = [];
      if (dataDefault.clearStatus && dataDefault.idExpen) {
        try {
          const imgTMBill = await axios.get(
            `${GET_LOAD_IMAGE_NEW_ALL}/7/${dataDefault.idExpen}`,
            { headers: HEADERS_UPIMAGE },
          );

          tmBillImages = (imgTMBill.data || []).map((img) => ({
            ...img,
            source: "TMBill",
          }));
        } catch (error) {
          console.error("Error loading TMBill images:", error);
        }
      }

      // ✅ 3. รอ loanPromises ทั้งหมด
      const loanResults = await Promise.all(loanPromises);
      const loanImages = loanResults.flat();

      // ✅ 4. รวมรูปทั้งหมด
      const allImages = [...loanImages, ...tmBillImages];

      console.log("All Images Data:", allImages);

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพสำหรับสัญญาทั้งหมด");
      }

      setFileListByContract(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  };

  // ============== RENDER DATA DETAIL ==============
  const renderDataDetail = (billData) => {
    console.log("billData:", billData);

    const groupedArray = billData.map((loan) => {
      return {
        CONTNO: loan.CONTNO,
        loanId: loan.loanId,
        lawsuitId: loan.lawsuitId,
        TMBILL: loan.TMBILL,
        SNAM: loan.SNAM,
        NAME1: loan.NAME1,
        NAME2: loan.NAME2,
        expenses: loan.workExpenseList || [],
      };
    });

    console.log("groupedArray:", groupedArray);
    setDataRender(groupedArray);

    // คำนวณ total เริ่มต้น
    const initialTotals = {};
    let grand = 0;

    groupedArray.forEach((group) => {
      const total = group.expenses.reduce(
        (sum, item) => sum + (parseFloat(item.PAY) || 0),
        0,
      );
      initialTotals[group.CONTNO] = total;
      grand += total;
    });

    setTotalPay(initialTotals);
    setGrandTotal(grand);
  };

  // ============== SEND DATA ==============
  const sendData = async (workExpenseList, payamtMark) => {
    if (workExpenseList.length === 0) {
      message.warning("กรุณากรอกข้อมูลอย่างน้อย 1 รายการ");
      return;
    }

    // setLoading(true);
    const payload = {
      TMBILL: dataDefault.TMBILL,
      payamtMark: payamtMark || null,
      clearStatus: 4, //ส่งหาแม่ทม
      userId: userId,
      workExpenseList: workExpenseList,
    };

    console.log("Payload to send:", payload);

    try {
      const response = await axios.post(POST_CLEAR_PAYMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status === 200 || response.status === 201) {
        console.log("อัพเดทข้อมูลสำเร็จ");
        message.success("เคลียร์เงินทดรองจ่ายสำเร็จ");
        return response.status;
      } else {
        console.log("Unexpected response status");
      }
    } catch (error) {
      console.error("Error sending data:", error);
      // const errorMsg = error.response?.data?.message || error.message;
      // message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpLoadIMG = useCallback(async (resultImgs, menu, data) => {
    const newFormData = new FormData();

    try {
      newFormData.append("id", data.id);
      newFormData.append("notis", 7);

      const sortedImgs = resultImgs
        .filter((img) => img.originalIndex !== undefined)
        .sort((a, b) => {
          const typeDiff = a.type - b.type;
          if (typeDiff !== 0) return typeDiff;
          return a.originalIndex - b.originalIndex;
        });

      for (const file of sortedImgs) {
        newFormData.append("file", file.imageCompressedFile);
        newFormData.append("menuType", 7);
        newFormData.append("imageType", file.type);
      }

      const response = await axios.post(POST_UPLOAD_IMAGE_NEW, newFormData, {
        headers: HEADERS_UPIMAGE,
      });

      if (response.status === 200) {
        return { success: true, status: response.status };
      }

      return { success: false, error: "อัปโหลดรูปไม่สำเร็จ" };
    } catch (error) {
      console.error("Upload error:", error);
      return { success: false, error: error.message };
    }
  }, []);

  // ============== ON FINISH ==============
  const onFinish = async (values) => {
    console.log("Form values:", values);

    const checkSlipCourt = validateAllContractsHaveImages();
    console.log("checkSlipCourt", checkSlipCourt);
    const checkTMBill = validateTMBillImages();

    const hasPaidAmount = checkSlipCourt?.missingContracts?.some((contract) => {
      return contract?.expenses?.some((expense) => {
        const payValue = values[`pay_${expense.id}`];
        return Number(payValue) > 0;
      });
    });

    console.log("hasPaidAmount", hasPaidAmount);

    if (!checkSlipCourt.isValid && hasPaidAmount) {
      return message.error("กรุณาอัพไฟล์ใบเสร็จศาล");
    }

    if (dataDefault.payamt - grandTotal >= 1) {
      if (
        (!values?.slip || values?.slip?.fileList?.length < 1) &&
        !checkTMBill.isValid
      ) {
        return message.error("กรุณาอัพโหลดสลิปโอนเงินคืนการเงิน");
      }
    }

    let workExpenseList = [];

    // วนลูปข้อมูลทั้งหมดจาก dataRender
    dataRender.forEach((loan) => {
      loan.expenses.forEach((expense) => {
        const payValue = values[`pay_${expense.id}`];

        // เพิ่มทุกรายการ (รวมถึงที่ไม่ได้กรอก)
        workExpenseList.push({
          id: expense.id,
          TMBILL: expense.TMBILL,
          lawsuitId: expense.lawsuitId,
          expenseTypeId: expense.expenseTypeId,
          NETPAY: expense.NETPAY,
          NETPAY_DT: expense.NETPAY_DT,
          PAY:
            payValue !== undefined && payValue !== null
              ? payValue
              : parseFloat(expense.PAY) || 0,
          loanId: loan.loanId,
          CONTNO: loan.CONTNO,
        });
      });
    });

    console.log("workExpenseList to send:", workExpenseList);

    setLoading(true);
    try {
      const statusResult = await sendData(workExpenseList, values.memo);
      if (!statusResult.success) {
        console.log(statusResult.error);
      }
      console.log("✅ ขั้นตอนที่ 1: บันทึกข้อมูลสำเร็จ");

      const shouldUploadImages = allImg?.length > 0;

      if (shouldUploadImages) {
        const uploadResult = await handleUpLoadIMG(allImg, 6, {
          id: dataDefault.idExpen,
        });

        if (uploadResult.success) {
          message.success("บันทึกใบเสร็จสำเร็จ");
        } else {
          console.warn("⚠️ อัปโหลดรูปภาพล้มเหลว:", uploadResult.error);
          message.warning("บันทึกข้อมูลสำเร็จ แต่อัปโหลดรูปภาพล้มเหลว");
        }
      } else {
        console.log("ℹ️ ไม่มีรูปภาพที่ต้องอัปโหลด");
      }

      if (funcUpdateStatus) {
        await funcUpdateStatus();
        console.log("✅ ขั้นตอนที่ 3: อัปเดทสถานะสำเร็จ");
      }
      setTimeout(() => {
        handleCancel();
      }, 500);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลให้ครบถ้วน");
  };

  // ============== HANDLE INPUT CHANGE ==============
  const handleInputChange = (value, contno, expenseId) => {
    console.log("Input change:", { value, contno, expenseId });

    if (value !== null && value !== undefined) {
      setBtnOn(true);
    }

    // อัปเดตผลรวมของสัญญานี้และยอดรวมทั้งหมด
    setTotalPay((prevTotal) => {
      const loanData = dataRender.find((item) => item.CONTNO === contno);

      if (!loanData) return prevTotal;

      const newTotal = loanData.expenses.reduce((sum, expense) => {
        if (expense.id === expenseId) {
          return sum + (parseFloat(value) || 0);
        }
        const formValue = form.getFieldValue(`pay_${expense.id}`);
        return sum + (parseFloat(formValue) || parseFloat(expense.PAY) || 0);
      }, 0);

      const updatedTotals = {
        ...prevTotal,
        [contno]: newTotal,
      };

      // คำนวณยอดรวมทั้งหมด
      const grand = Object.values(updatedTotals).reduce(
        (sum, val) => sum + val,
        0,
      );
      setGrandTotal(grand);

      return updatedTotals;
    });
  };

  // ✅ Helper function สำหรับ compress รูป
  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ✅ Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // ✅ Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => {
      if (f.type === "application/pdf" || f.name.endsWith(".pdf")) {
        // Custom icon logic ถ้าต้องการ
      }
      return f;
    });

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // ✅ Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // ✅ Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 11), //11 = สลิปเคลียร์เบิกชั้นศาล
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  // ลบรูป (รับ array)
  const handleDeleteIMG = async (images) => {
    if (!images || images.length === 0) return;

    setLoading(true);
    try {
      // ✅ แก้ axios config - headers ต้องอยู่ใน object เดียวกับ data
      const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
        data: images,
        headers: HEADERS_UPIMAGE,
      });

      if (res.status === 200) {
        const selectedPaths = new Set(images.map((img) => img.path));
        setFileListByContract((prev) =>
          prev.filter((img) => !selectedPaths.has(img.path)),
        );
        message.success("ลบรูปสำเร็จ");
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
      console.error("err", err);
    } finally {
      setLoading(false);
    }
  };

  // ลบรูปที่เลือกทั้งหมด
  const handleDeleteSelectedImages = () => {
    if (selectedImages.length === 0) {
      message.warning("กรุณาเลือกรูปที่ต้องการลบ");
      return;
    }

    Modal.confirm({
      title: "ยืนยันการลบ",
      content: `คุณต้องการลบรูปภาพที่เลือกทั้งหมด ${selectedImages.length} รูปใช่หรือไม่?`,
      okText: "ลบ",
      okType: "danger",
      cancelText: "ยกเลิก",
      onOk: async () => {
        await handleDeleteIMG(selectedImages);
        setSelectedImages([]);
      },
    });
  };

  // เลือกรูป
  const handleSelectImage = (image) => {
    setSelectedImages((prev) => {
      const isSelected = prev.some((img) => img.path === image.path);
      if (isSelected) {
        return prev.filter((img) => img.path !== image.path);
      } else {
        return [...prev, image];
      }
    });
  };

  // ✅ ลบรูปเดียว - ส่งเป็น array
  const handleDeleteSingleImage = async (image) => {
    await handleDeleteIMG([image]);
  };
  // เปิด Modal
  const handleAddImage = (loan) => {
    setCurrentLoan(loan);
    setUploadModalVisible(true);
  };

  // ปิด Modal
  const handleCancelUpload = () => {
    setUploadModalVisible(false);
    setCurrentLoan(null);
  };

  // เมื่ออัปโหลดสำเร็จ
  const handleUploadSuccess = async (data) => {
    console.log("Upload success:", data);

    // Reload รูปภาพใหม่
    await loadPath();

    // ปิด Modal
    handleCancelUpload();
  };

  // เช็คว่าทุกสัญญามีรูปภาพ imageType === 10 ครบไหม
  const validateAllContractsHaveImages = () => {
    // สมมติ loans คือ array ของสัญญาทั้งหมด
    const contractsWithoutImages = dataRender.filter((loan) => {
      const hasImage = (fileListByContract || []).some(
        (e) => e?.imageType === 10 && e.CONTNO === loan.CONTNO,
      );
      return !hasImage; // return true ถ้าไม่มีรูป
    });

    return {
      isValid: contractsWithoutImages.length === 0,
      missingContracts: contractsWithoutImages,
    };
  };

  // เช็ครูปภาพ imageType 11 (ตาม idExpen)
  const validateTMBillImages = () => {
    if (!dataDefault.idExpen) {
      return { isValid: true, hasTMBillImage: false };
    }

    const hasImage = (fileListByContract || []).some(
      (e) => e?.imageType === 11 && e.id === dataDefault.idExpen,
    );

    return {
      isValid: hasImage,
      hasTMBillImage: hasImage,
    };
  };

  const handleDataPdf = (result, loanData) => {
    if (!result || !loanData) return;
    setLoading(true);

    try {
      // ── หา total_amount ตาม page ─────────────────────
      const getAmountByPage = (pageNum) =>
        result.pages?.find((p) => p.page === pageNum)?.total_amount ?? 0;

      // ── หา total_amount ตาม item_name keyword ─────────
      const getAmountByItemName = (keyword) => {
        for (const page of result.pages ?? []) {
          const found = page.items?.find((item) =>
            item.item_name?.includes(keyword),
          );
          if (found) return page.total_amount ?? 0;
        }
        return 0;
      };

      // ── map description → amount ──────────────────────
      const valueMap = {
        ค่านำคำบังคับ: getAmountByItemName("ค่าส่งคำคู่ความเพิ่มเติม"),
      };

      // ── set form ─────────────────────────────────────
      const newValues = {};
      loanData.expenses?.forEach((expense) => {
        const amount = valueMap[expense.description];
        if (amount !== undefined && amount !== 0) {
          newValues[`pay_${expense.id}`] = amount;
          handleInputChange(amount, loanData.CONTNO, expense.id);
        }
      });

      if (Object.keys(newValues).length > 0) {
        form.setFieldsValue(newValues);
        message.success("กรอกข้อมูลจาก PDF สำเร็จ");
      } else {
        message.warning("ไม่พบข้อมูลที่ตรงกับรายการค่าใช้จ่าย");
      }
    } catch (error) {
      console.error("handleDataPdf error:", error);
      message.error("เกิดข้อผิดพลาดในการอ่านข้อมูล PDF");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`เคลียร์เงินทดรองจ่าย ${dataDefault?.TMBILL || ""}`}
      open={open}
      onCancel={handleCancel}
      width={900}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="Loading...">
        <Card>
          <Form
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 24,
            }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            style={{
              maxWidth: 850,
            }}
            form={form}
          >
            {/* ============== แสดงแต่ละสัญญา ============== */}
            {dataRender?.map((loan, loanIndex) => {
              const total = loan.expenses.reduce(
                (sum, item) => sum + (parseFloat(item.PAY) || 0),
                0,
              );
              // ✅ เช็ครูปภาพในแต่ละสัญญา
              const hasImage = validateAllContractsHaveImages();
              console.log("hasImage", hasImage);

              return (
                <div
                  key={loanIndex}
                  style={{
                    marginBottom: "20px",
                    border: "1px solid #ccc",
                    padding: "15px",
                    background:
                      loanIndex % 2 === 0
                        ? "linear-gradient(135deg, #f5f7fa 0%, #FFEBB7 100%)"
                        : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{ marginBottom: "15px" }}
                  >
                    <Text strong style={{ fontSize: "16px" }}>
                      สัญญา: {loan.CONTNO} {loan.SNAM} {loan.NAME1} {loan.NAME2}
                    </Text>
                    {hasImage.isValid ? (
                      <Tag color="green">✓ มีใบเสร็จศาลแล้ว</Tag>
                    ) : (
                      <Tag color="red">✗ ยังไม่มีใบเสร็จศาล</Tag>
                    )}
                  </Flex>

                  {/* รายการค่าใช้จ่าย */}
                  {loan.expenses?.map((expense, expenseIndex) => (
                    <div
                      key={expenseIndex}
                      style={{
                        marginBottom: "10px",
                        padding: "10px",
                        background: "rgba(255, 255, 255, 0.5)",
                        borderRadius: "5px",
                      }}
                    >
                      <Form.Item
                        label={expense.description || "ไม่ระบุ"}
                        name={`pay_${expense.id}`}
                        style={{ marginBottom: "0" }}
                      >
                        <InputNumber
                          suffix="บาท"
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          size="large"
                          placeholder={`ยอดตั้งเบิก: ${
                            expense.NETPAY || 0
                          } บาท`}
                          defaultValue={parseFloat(expense.PAY) || 0}
                          style={{ width: "100%", color: "black" }}
                          onChange={(value) =>
                            handleInputChange(value, loan.CONTNO, expense.id)
                          }
                        />
                      </Form.Item>
                      <Text
                        type="secondary"
                        style={{ fontSize: "11px", paddingLeft: "10px" }}
                      >
                        ยอดตั้งเบิก: {currencyFormatPoint(expense.NETPAY) || 0}{" "}
                        บาท
                      </Text>
                    </div>
                  ))}

                  {/* ยอดรวมของสัญญานี้ */}
                  <Form.Item label="รวม" style={{ marginTop: "10px" }}>
                    <InputNumber
                      suffix="บาท"
                      value={totalPay[loan.CONTNO] ?? total}
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      style={{
                        width: "100%",
                        color: "#1890ff",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                      size="large"
                      disabled
                    />
                  </Form.Item>
                  {/* แสดงรูปภาพที่อัปโหลดแล้ว */}
                  <Spin spinning={loading} size="large" tip="Loading...">
                    <Row gutter={[8, 8]} justify="center">
                      {(fileListByContract || [])
                        .filter(
                          (e) =>
                            e?.imageType === 10 && loan.CONTNO === e.CONTNO,
                        )
                        .map((e, index) => {
                          const isPdf = e.path?.toLowerCase().endsWith(".pdf");

                          return (
                            <Col
                              key={e.path || index}
                              xs={12}
                              sm={8}
                              md={6}
                              lg={6}
                              xl={6}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {/* Checkbox เลือกรูป */}
                                <Checkbox
                                  checked={selectedImages?.some(
                                    (img) => img.path === e.path,
                                  )}
                                  onChange={() => handleSelectImage(e)}
                                  style={{
                                    position: "absolute",
                                    top: 8,
                                    left: 8,
                                    zIndex: 10,
                                    backgroundColor: "white",
                                    padding: "4px",
                                    borderRadius: "4px",
                                  }}
                                />

                                <Card
                                  hoverable
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    padding: "8px",
                                  }}
                                >
                                  {isPdf ? (
                                    <div
                                      onClick={() =>
                                        window.open(
                                          `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                          "_blank",
                                        )
                                      }
                                      style={{
                                        height: "120px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        backgroundColor: "#f0f0f0",
                                        borderRadius: "8px",
                                        border: "1px solid #d9d9d9",
                                      }}
                                    >
                                      <FilePdfOutlined
                                        style={{
                                          fontSize: "40px",
                                          color: "#ff4d4f",
                                        }}
                                      />
                                      <span
                                        style={{
                                          marginTop: "8px",
                                          fontSize: "12px",
                                          color: "#666",
                                        }}
                                      >
                                        คลิกเพื่อเปิด PDF
                                      </span>
                                    </div>
                                  ) : (
                                    <Image
                                      width="100%"
                                      height="120px"
                                      src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                      alt={`รูปภาพ ${index}`}
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                      preview={{
                                        src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                      }}
                                    />
                                  )}
                                </Card>
                              </div>
                            </Col>
                          );
                        })}
                    </Row>

                    {/* แสดงข้อความถ้าไม่มีรูป */}
                    {(fileListByContract || []).filter(
                      (e) => e?.imageType === 10 && loan.CONTNO === e.CONTNO,
                    ).length === 0 && (
                      <Empty
                        description="ยังไม่มีรูปภาพ"
                        style={{ marginTop: 24 }}
                      />
                    )}
                  </Spin>
                  <div style={{ textAlign: "center", margin: 10 }}>
                    <Space>
                      <Button
                        variant="outlined"
                        color="blue"
                        icon={<PlusOutlined />}
                        onClick={() => handleAddImage(loan)} // ส่ง loan เข้าไป
                      >
                        เพิ่มรูป
                      </Button>
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={handleDeleteSelectedImages}
                        disabled={selectedImages.length === 0}
                      >
                        ลบรูปที่เลือก ({selectedImages.length})
                      </Button>
                    </Space>
                  </div>
                </div>
              );
            })}

            <Divider />
            {/* ============== อัปโหลดสลิปโอนเงิน ============== */}
            <Form.Item label="ยอดเบิกรวมทั้งหมด">
              <Text strong style={{ fontSize: "18px", color: "blue" }}>
                {currencyFormatPoint(dataDefault.payamt)} บาท{" "}
              </Text>
            </Form.Item>
            <Form.Item label="ยอดเคลียร์รวมทั้งหมด">
              <Text
                strong
                style={{
                  fontSize: "18px",
                  color: dataDefault.payamt - grandTotal < 0 ? "green" : "red",
                }}
              >
                {currencyFormatPoint(grandTotal)} บาท{" "}
              </Text>
            </Form.Item>
            <Form.Item label="ผลต่าง">
              <Text
                strong
                style={{
                  fontSize: "18px",
                  color: dataDefault.payamt - grandTotal < 0 ? "green" : "red",
                }}
              >
                {currencyFormatPoint(dataDefault.payamt - grandTotal)} บาท{" "}
                {dataDefault.payamt - grandTotal >= 1
                  ? "(โอนคืนการเงิน)"
                  : dataDefault.payamt - grandTotal === 0
                    ? null
                    : "(การเงินโอนคืน)"}
              </Text>
            </Form.Item>

            {dataDefault.payamt - grandTotal > 0 && (
              <>
                <Form.Item label="โอนบริษัท">
                  <Text
                    strong
                    copyable
                    style={{
                      fontSize: "18px",
                      color:
                        dataDefault.payamt - grandTotal < 0 ? "green" : "red",
                    }}
                  >
                    {allCompaniesOptions.find(
                      (allCom) => allCom.value === dataDefault.COMPANY_ID,
                    )?.data.bank || "-"}
                  </Text>
                </Form.Item>
                <Form.Item label="อัปโหลดสลิปโอนเงิน" name="slip">
                  <Dragger
                    {...uploadProps}
                    style={{
                      width: "100%",
                      height: "150px",
                      margin: "0 auto",
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined
                        style={{ color: "green", fontSize: "40px" }}
                      />
                    </p>
                    <p className="ant-upload-text">
                      กรุณาคลิกหรือลากเพื่อเลือกไฟล์
                    </p>
                    <p className="ant-upload-hint">รองรับเฉพาะไฟล์รูปภาพ</p>
                  </Dragger>
                </Form.Item>
              </>
            )}

            <Spin spinning={loading} size="large" tip="Loading...">
              <Row gutter={[8, 8]} justify="center">
                {(fileListByContract || [])
                  .filter(
                    (e) => e?.imageType === 11 && dataDefault.idExpen === e.id,
                  )
                  .map((e, index) => {
                    const isPdf = e.path?.toLowerCase().endsWith(".pdf");

                    return (
                      <Col
                        key={e.path || index}
                        xs={12}
                        sm={8}
                        md={6}
                        lg={6}
                        xl={6}
                      >
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          {/* ปุ่มลบแบบ Icon */}
                          <Popconfirm
                            title="ยืนยันการลบ"
                            description="ต้องการลบรูปภาพนี้?"
                            onConfirm={() => handleDeleteSingleImage(e)}
                            okText="ลบ"
                            cancelText="ยกเลิก"
                            okButtonProps={{ danger: true }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                zIndex: 10,
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "rgba(255, 77, 79, 0.9)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <DeleteOutlined
                                style={{ color: "#fff", fontSize: 12 }}
                              />
                            </div>
                          </Popconfirm>

                          <Card
                            hoverable
                            style={{
                              width: "100%",
                              textAlign: "center",
                              padding: "8px",
                            }}
                          >
                            {isPdf ? (
                              <div
                                onClick={() =>
                                  window.open(
                                    `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                    "_blank",
                                  )
                                }
                                style={{
                                  height: "120px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "8px",
                                  border: "1px solid #d9d9d9",
                                }}
                              >
                                <FilePdfOutlined
                                  style={{ fontSize: "40px", color: "#ff4d4f" }}
                                />
                                <span
                                  style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    color: "#666",
                                  }}
                                >
                                  คลิกเพื่อเปิด PDF
                                </span>
                              </div>
                            ) : (
                              <Image
                                width="100%"
                                height="120px"
                                src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                alt={`รูปภาพ ${index}`}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                                preview={{
                                  src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                }}
                              />
                            )}
                          </Card>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </Spin>

            {/* ============== หมายเหตุ ============== */}
            <Form.Item
              label="หมายเหตุ"
              name="memo"
              style={{ width: "100%", marginTop: "10px" }}
            >
              <TextArea rows={4} placeholder="ระบุหมายเหตุ (ถ้ามี)" />
            </Form.Item>

            {/* ============== ปุ่ม ============== */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={handleCancel}
                size="large"
                style={{ marginRight: "20px" }}
              >
                ปิด
              </Button>

              <Button type="primary" size="large" htmlType="submit">
                บันทึก
              </Button>
            </div>
          </Form>
        </Card>
      </Spin>
      {uploadModalVisible && (
        <AddImage
          visible={uploadModalVisible}
          onCancel={handleCancelUpload}
          onSuccess={handleUploadSuccess}
          loanData={currentLoan}
          imageType={10}
          apiUrl={POST_UPLOAD_IMAGE_NEW}
          headers={HEADERS_UPIMAGE}
          title="อัปโหลดใบเสร็จศาล"
          handleDataPdf={handleDataPdf}
        />
      )}
    </Modal>
  );
};

export default ClearAdvanePayment;
